'use strict';
/* global $, angular */

angular.module("app.common").directive('datePicker', [function() {
	return function(scope, elem, attrs) {
		$(function () {
            elem.find("#datetimepicker1").datetimepicker(); 
        });
	};
}]);